import { Paper, Typography } from "@mui/material";
import React from "react";

const SectionCard = React.forwardRef(({ title, children, sx }, ref) => (
  <Paper
    ref={ref}
    elevation={0}
    sx={{
      width: "100%",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 3,
      p: 2,
      py: 0,
      mb: 2.5,
      ...sx,
    }}
  >
    {title && (
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 700, mb: 2.5, letterSpacing: "-0.01em" }}
      >
        {title}
      </Typography>
    )}
    {children}
  </Paper>
));

export default SectionCard;
